'use client';

import { PaybackConnected } from '@packages/order/src/components/Payback/PaybackConnected';
import { PaybackDisconnected } from '@packages/order/src/components/Payback/PaybackDisconnected';
import { PaybackReauthenticate } from '@packages/order/src/components/Payback/PaybackReauthenticate';
import { useNotification } from '@packages/shared/src/providers/NotificationProvider/useNotification';
import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import {
  useLoyaltyApi,
  LoyaltyStatusResponseStatusEnum,
} from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { defineMessages, useIntl } from 'react-intl';
import useSWR from 'swr';
import { PaybackAccountDataFetchProvider } from '@packages/order/src/components/Payback/PaybackAccountDataFetchProvider';
import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';

const messages = defineMessages({
  paybackHeadline: {
    defaultMessage: 'Mein PAYBACK',
    id: 'Payback.Headline',
  },
  ErrorMessage: {
    id: 'PaybackPage.ErrorMessage',
    defaultMessage:
      'Entschuldige, irgendetwas ist schief gelaufen. Probiere es später noch einmal.',
  },
});

const PaybackPage = () => {
  const { locale, formatMessage } = useIntl();
  const { getCookies } = useCookies();
  const { appView } = getCookies();
  const { loggedIn, softLoggedIn } = useLoginState();
  const { addNotification } = useNotification();
  const loyaltyApi = useLoyaltyApi();
  const { data } = useSWR(
    loyaltyApi && loggedIn ? 'getLoyaltyConnectionStatus' : null,
    () =>
      loyaltyApi?.getLoyaltyConnectionStatus({
        ecLocale: locale,
      }),
    {
      revalidateOnFocus: false,
      onSuccess: (callbackData) => {
        if (callbackData?.errors) {
          addNotification({
            severity: 'error',
            message: callbackData.errors.elements[0].description,
            duration: 5000,
            onClose: () => {},
          });
        }
        if (callbackData?.warnings) {
          addNotification({
            severity: 'warning',
            message: callbackData.warnings.elements[0].description,
            duration: 5000,
            onClose: () => {},
          });
        }
      },
      onError: () =>
        addNotification({
          message: formatMessage(messages.ErrorMessage),
          severity: 'error',
          duration: 5000,
        }),
    },
  );
  const isApp = appView === 'true';
  return (
    <>
      <h1>{formatMessage(messages.paybackHeadline)}</h1>
      {data?.status === LoyaltyStatusResponseStatusEnum.NoConnection && (
        <PaybackDisconnected enableSignIn />
      )}
      {data?.status === LoyaltyStatusResponseStatusEnum.ConnectionInactive && (
        <PaybackDisconnected enableSignIn={false} />
      )}
      {data?.status === LoyaltyStatusResponseStatusEnum.ConnectionEstablished && (
        <PaybackAccountDataFetchProvider>
          <PaybackConnected />
        </PaybackAccountDataFetchProvider>
      )}
      {data?.status === LoyaltyStatusResponseStatusEnum.ReauthenticationNeeded && (
        <PaybackReauthenticate />
      )}
    </>
  );
};
// eslint-disable-next-line import-x/no-default-export
export default PaybackPage;
